import { BaseRepository } from "@/repositories/base-repository"
import { type IKnownBusinessEntityContact } from "@/interfaces/api/known-business-entity-contact.interface.ts"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import type { QuoteState } from "@/types/quote"

export class KnownBusinessEntityContactRepository extends BaseRepository<IKnownBusinessEntityContact> {
  protected resourcePath = "core/known-business-entities-contacts"

  async getQuoteDraft(contactId: string): Promise<QuoteState | null> {
    const response = await new HTTPRequestBuilder(
      HTTPMethods.GET,
      `${this.resourcePath}/${contactId}/quote-draft/`
    )
      // Preserve arbitrary draft strings: the usual response interceptor turns
      // date-looking strings into Moment objects, including rental dates.
      .setResponseType("text")
      .build()
      .execute()
    return JSON.parse(response.data).quoteDraft
  }

  async saveQuoteDraft(contactId: string, quoteDraft: QuoteState): Promise<void> {
    await new HTTPRequestBuilder(HTTPMethods.PUT, `${this.resourcePath}/${contactId}/quote-draft/`)
      .setData({ quoteDraft })
      .setExpectedStatusCode(204)
      .build()
      .execute()
  }
}
